import React, { useRef, useEffect, Suspense } from 'react';

/**
 * @description determine whether it is a browser environment
 */
var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
};

var isBrowser = /*#__PURE__*/canUseDOM();
var Repeater = function Repeater(props) {
  // props
  var mode = props.mode,
    children = props.children;
  // refs
  var promiseRef = useRef(null);
  var resolveRef = useRef(null);
  // methods
  var resolvePromise = function resolvePromise(ignoreMode) {
    if ((ignoreMode || mode === "visible") && typeof resolveRef.current === "function") {
      resolveRef.current();
      resolveRef.current = null;
      promiseRef.current = null;
    }
  };
  // effect
  useEffect(function () {
    return function () {
      return resolvePromise(true);
    };
  }, []);
  if (mode === "hidden") {
    if (resolveRef.current === null) {
      promiseRef.current = new Promise(function (resolve) {
        return resolveRef.current = resolve;
      });
    }
    var promise = promiseRef.current;
    // @ts-ignore
    if ("use" in React && typeof React.use === "function") {
      // @ts-ignore
      React.use(promise);
    } else {
      throw promise;
    }
  }
  // warning
  // ? throw a new promise is pending
  if (isBrowser && mode === "hidden") {
    console.error(navigator.language === "zh-CN" ? "\n        \u7531\u4E8Ereact\u7684\u9650\u5236\uFF0C\u7531startTransition\u6216\u8005useDeferredValue\u89E6\u53D1\u7684\u66F4\u65B0\u5F15\u8D77\u7684\u7EC4\u4EF6\u6302\u8D77\u4E0D\u4F1A\u6E32\u67D3\u56DE\u9000\uFF0C\u5177\u4F53\u53EF\u4EE5\u53C2\u8003\n        https://zh-hans.react.dev/reference/react/Suspense#preventing-already-revealed-content-from-hiding\n      " : "\n      Due to the limitations of react, component suspension caused by updates triggered by startTransition or useDeferredValue will not render the rollback. For details, please refer to\n      https://react.dev/reference/react/Suspense#preventing-already-revealed-content-from-hiding\n      ");
  }
  resolvePromise();
  return React.createElement(React.Fragment, null, typeof children === 'function' ? children(mode) : children);
};

var isSupportStableActivity = ("Activity" in React);
var isBrowser$1 = /*#__PURE__*/canUseDOM();
var NativeActivity = isSupportStableActivity
// @ts-ignore
? React.Activity : "unstable_Activity" in React
// @ts-ignore
? React.unstable_Activity : null;
if (isBrowser$1 && isSupportStableActivity) {
  console.warn(navigator.language === "zh-CN" ? '检测到您使用的react已经原生支持了Activity，我们 建议您迁移至原生Activity。' : 'It is detected that the react you are using already supports Activity natively. We recommend that you migrate to native Activity.');
}
/**
 *
 * @param {IProps} props
 * @description This is a component that keeps its state while hiding it
 * @example
 * when visible
 * <Activity mode="visible">
 *  <Child />
 * </Activity>
 * when hidden
 * <Activity mode="hidden">
 *  <Child />
 * </Activity>
 */
var Activity = function Activity(props) {
  // props
  var mode = props.mode,
    children = props.children;
  if (NativeActivity) {
    return React.createElement(NativeActivity, {
      mode: mode
    }, children);
  }
  return React.createElement(Suspense, {
    fallback: null
  }, React.createElement(Repeater, {
    mode: mode
  }, children));
};

export { Activity, Activity as Offscreen };
//# sourceMappingURL=react-offscreen.esm.js.map
